import api from './api';

/**
 * Obtener todos los atributos
 */
export const getAttributes = async (params = {}) => {
  try {
    console.log('📡 [attributesService] Enviando petición GET a:', '/api/configuration/attributes');
    console.log('📋 [attributesService] Parámetros:', params);
    
    const response = await api.get('/configuration/attributes', { params });
    
    console.log('✅ [attributesService] Respuesta recibida exitosamente');
    console.log('📦 [attributesService] Response completo:', response);
    console.log('📊 [attributesService] Response.data:', response.data);
    console.log('🔍 [attributesService] Tipo de response.data:', typeof response.data);
    console.log('📈 [attributesService] response.data.success:', response.data?.success);
    console.log('📋 [attributesService] response.data.data:', response.data?.data);
    console.log('🔢 [attributesService] Cantidad de atributos:', Array.isArray(response.data?.data) ? response.data.data.length : 'No es un array');
    
    if (Array.isArray(response.data?.data)) {
      console.log('📝 [attributesService] Primeros 3 atributos:', response.data.data.slice(0, 3));
      console.log('🔑 [attributesService] Estructura de un atributo:', response.data.data[0] ? Object.keys(response.data.data[0]) : 'No hay atributos');
    }
    
    return response.data;
  } catch (error) {
    console.error('❌ [attributesService] Error al obtener atributos:', error);
    console.error('📊 [attributesService] Error.response:', error.response);
    console.error('📋 [attributesService] Error.response?.data:', error.response?.data);
    console.error('🔢 [attributesService] Error.status:', error.response?.status);
    throw error;
  }
};

/**
 * Obtener un atributo por ID
 */
export const getAttribute = async (id) => {
  try {
    const response = await api.get(`/configuration/attributes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener atributo:', error);
    throw error;
  }
};

/**
 * Crear un nuevo atributo
 */
export const createAttribute = async (attributeData) => {
  try {
    console.log('📡 [attributesService] Enviando petición POST a:', '/api/configuration/attributes');
    console.log('📤 [attributesService] Datos a enviar:', attributeData);
    
    const response = await api.post('/configuration/attributes', attributeData);
    
    console.log('✅ [attributesService] Atributo creado exitosamente');
    console.log('📦 [attributesService] Response completo:', response);
    console.log('📊 [attributesService] Response.data:', response.data);
    console.log('🔍 [attributesService] Atributo creado:', response.data?.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ [attributesService] Error al crear atributo:', error);
    console.error('📊 [attributesService] Error.response:', error.response);
    console.error('📋 [attributesService] Error.response?.data:', error.response?.data);
    throw error;
  }
};

/**
 * Actualizar un atributo
 */
export const updateAttribute = async (id, attributeData) => {
  try {
    console.log('📡 [attributesService] Enviando petición PUT a:', `/api/configuration/attributes/${id}`);
    console.log('📤 [attributesService] ID de atributo:', id);
    console.log('📤 [attributesService] Datos a enviar:', attributeData);
    
    const response = await api.put(`/configuration/attributes/${id}`, attributeData);
    
    console.log('✅ [attributesService] Atributo actualizado exitosamente');
    console.log('📦 [attributesService] Response completo:', response);
    console.log('📊 [attributesService] Response.data:', response.data);
    console.log('🔍 [attributesService] Atributo actualizado:', response.data?.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ [attributesService] Error al actualizar atributo:', error);
    console.error('📊 [attributesService] Error.response:', error.response);
    console.error('📋 [attributesService] Error.response?.data:', error.response?.data);
    throw error;
  }
};

/**
 * Eliminar un atributo
 */
export const deleteAttribute = async (id) => {
  try {
    console.log('📡 [attributesService] Enviando petición DELETE a:', `/api/configuration/attributes/${id}`);
    console.log('📤 [attributesService] ID de atributo a eliminar:', id);
    
    const response = await api.delete(`/configuration/attributes/${id}`);
    
    console.log('✅ [attributesService] Atributo eliminado exitosamente');
    console.log('📦 [attributesService] Response completo:', response);
    console.log('📊 [attributesService] Response.data:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ [attributesService] Error al eliminar atributo:', error);
    console.error('📊 [attributesService] Error.response:', error.response);
    console.error('📋 [attributesService] Error.response?.data:', error.response?.data);
    throw error;
  }
};

